<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UuqnH/images/9780316519120.jpg?1732976220331" alt="This image is the cover for the book Adrift"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Adrift
      </h1>
      <p class="bookDescription body article font2">
        <b>"An edge-of-the-seat epic of survival and adventure in deep space." -- Gareth L. Powell, BSFA Award-Winning author</b><br/><br/>Sigma Station. The ultimate luxury hotel, in the far reaches of space.<br/><br/>For one small group, a tour of the Horsehead Nebula is meant to be a short but stunning highlight in the trip of a lifetime.<br/><br/>But when a mysterious ship destroys Sigma Station and everyone on it, suddenly their tourist shuttle is stranded.<br/><br/>They have no weapons. No food. No water. No one back home knows they're alive.<br/><br/>And the mysterious ship is hunting them.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rob Boffard
      </h2>
      
      <p class="authorDescription body article"><B>Rob Boffard</B> is a South African author who splits his time between London, Vancouver and Johannesburg. He has worked as a journalist for over a decade, and has written articles for publications in more than a dozen countries, including the <I>Guardian</I> and <I>Wired</I> in the UK.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14e46fbd